
export class Auth {
    public token: Token;
    public assignors: Assignors[];
    public accessToken: string;
    public authenticated: boolean;
    public created: Date;
    public expiration: Date;
    public message: string;
    public refreshToken: string;
    public userReferenceId: string;
    public isAnonymous: boolean = false;
    public userAssignorId: string = null;
    public assignorGuid: string = null;
    public accountId: string = null;
    public email: string;
    public pessoaId: string = null;
    public assignorName: string
}

class Token {
    constructor(
        public accessToken: string,
        public authenticated: boolean,
        public created: Date,
        public expiration: Date,
        public message: string,
        public refreshToken: string,
        public userReferenceId: string,
        public isAnonymous: boolean = false,
        public userAssignorId: string = null,
        public assignorGuid: string = null,
        public accountId: string = null,
        public email: string,
        public pessoaId: string = null,
        public assignorName: string
    ) { }
}

export class Assignors {
    public transitoryToken: string;
    public assignorName: string;
    public hasPin: boolean;
    public blocked: boolean;
    public selected?: boolean;
}

export class RegistryAuth {
    constructor(
        public accessToken: string,
        public authenticated: boolean,
        public created: Date,
        public expiration: Date,
        public message: string,
        public refreshToken: string,
        public userReferenceId: string,
        public isAnonymous: boolean = false,
        public userAssignorId: string = null,
        public assignorGuid: string = null,
        public accountId: string = null,
        public email: string,
        public pessoaId: string = null,
        public assignorName: string
    ) { }
}
